// 触屏手势（FR-3.1）：左缘右滑唤出历史抽屉、左滑隐藏；问答气泡长按弹出菜单。
export interface GestureHooks {
  isPanelOpen: () => boolean;
  openDrawer: () => void;
  closePanels: () => void;
  onLongPress: (bubble: HTMLElement, x: number, y: number) => void;
}

const SWIPE_MIN = 56; // 触发位移
const EDGE = 32; // 左缘判定宽度
const LONG_PRESS_MS = 480;
const MOVE_CANCEL = 12;

export function initGestures(hooks: GestureHooks): void {
  let sx = 0,
    sy = 0,
    st = 0,
    tracking = false;

  // ---- 滑动唤出/隐藏侧栏 ----
  document.addEventListener(
    "touchstart",
    (e) => {
      if (e.touches.length !== 1) {
        tracking = false;
        return;
      }
      const tch = e.touches[0];
      sx = tch.clientX;
      sy = tch.clientY;
      st = Date.now();
      tracking = true;
    },
    { passive: true },
  );

  document.addEventListener(
    "touchend",
    (e) => {
      if (!tracking) return;
      tracking = false;
      const tch = e.changedTouches[0];
      const dx = tch.clientX - sx;
      const dy = tch.clientY - sy;
      const dt = Date.now() - st;
      if (dt > 600) return;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.6) return;

      if (dx > 0) {
        // 右滑：仅从左缘起手才唤出历史，避免与页面内滚动冲突
        if (sx <= EDGE && !hooks.isPanelOpen()) hooks.openDrawer();
      } else {
        // 左滑：隐藏已打开的面板
        if (hooks.isPanelOpen()) hooks.closePanels();
      }
    },
    { passive: true },
  );

  // ---- 气泡长按 ----
  let lpTimer: number | null = null;
  let lpX = 0,
    lpY = 0;

  const clearLP = () => {
    if (lpTimer !== null) {
      clearTimeout(lpTimer);
      lpTimer = null;
    }
  };

  document.addEventListener(
    "touchstart",
    (e) => {
      const target = (e.target as HTMLElement)?.closest?.(
        "[data-bubble]",
      ) as HTMLElement | null;
      if (!target) return;
      const tch = e.touches[0];
      lpX = tch.clientX;
      lpY = tch.clientY;
      clearLP();
      lpTimer = window.setTimeout(() => {
        lpTimer = null;
        if (navigator.vibrate) navigator.vibrate(12);
        hooks.onLongPress(target, lpX, lpY);
      }, LONG_PRESS_MS);
    },
    { passive: true },
  );

  document.addEventListener(
    "touchmove",
    (e) => {
      if (lpTimer === null) return;
      const tch = e.touches[0];
      if (Math.abs(tch.clientX - lpX) > MOVE_CANCEL || Math.abs(tch.clientY - lpY) > MOVE_CANCEL)
        clearLP();
    },
    { passive: true },
  );

  document.addEventListener("touchend", clearLP, { passive: true });
  document.addEventListener("touchcancel", clearLP, { passive: true });

  // 桌面端：右键也唤出同一菜单
  document.addEventListener("contextmenu", (e) => {
    const target = (e.target as HTMLElement)?.closest?.("[data-bubble]") as HTMLElement | null;
    if (!target) return;
    e.preventDefault();
    hooks.onLongPress(target, e.clientX, e.clientY);
  });
}
